<div
  class="panel-card"
  [ngClass]="{
    'panel-card-muted': !hasNotifications && !hasActiveOrder,
    'panel-card-notifications-collapsed': notificationsCollapsed,
    'panel-card-available': tableStatus === 1,
    'panel-card-locked': tableStatus === 3,
    'panel-card-reserved': tableStatus === 4,
    'panel-card-occupied': tableStatus === 2
  }">
  <div
    *ngIf="notificationsCount > 0"
    class="notification-badge"
    [ngClass]="{
      'notification-badge-ltr': !language.isArabic,
      'notification-badge-rtl': language.isArabic
    }">
    {{ notificationsCount > 99 ? '99+' : notificationsCount }}
  </div>

  <div class="panel-card-main">
    <div class="panel-card-header">
      <div>
        <span class="panel-card-label">{{ 'Table' | translate }}</span>
        <h3>{{ tableNumber }}</h3>
      </div>
      <div class="panel-card-icon">
        <img *ngIf="tableStatus === 1" src="assets/images/emptyTable.png" alt="" />
        <img *ngIf="tableStatus === 2" src="assets/images/accptedOrder.png" alt="" />
        <img *ngIf="tableStatus === 3" src="assets/images/lockTable.svg" alt="" />
        <img *ngIf="tableStatus === 4" src="assets/images/ReservedTable.png" alt="" />
      </div>
    </div>

    <div class="panel-card-status-row">
      <span class="panel-card-status">
        <span class="panel-status-dot"></span>
        <span>{{ title | formatType }}</span>
      </span>
      <span class="panel-card-time">{{ time }}</span>
    </div>

    <div *ngIf="hasActiveOrder" class="panel-order-active">
      <div class="panel-order-state">
        <span class="panel-order-title">
          <span class="panel-order-pulse"></span>
          <span>{{ 'Order active' | translate }}</span>
        </span>
        <span class="panel-order-time">{{ orderCreatedTime }}</span>
      </div>
      <div class="panel-order-meta">
        <strong>
          <span>{{ 'Final Amount' | translate }}</span>
          {{ totalAmount | dividePrice }} {{ currency | translate }}
        </strong>
      </div>
    </div>

    <div class="panel-notifications-toolbar">
      <div class="panel-notifications-meta">
        <span class="panel-notifications-label">{{ 'Notifications' | translate }}</span>
        <span class="panel-notifications-total">{{ visibleNotificationsCount }}</span>
      </div>
      <button
        type="button"
        class="panel-notifications-toggle"
        [attr.aria-expanded]="!notificationsCollapsed"
        [attr.aria-label]="(notificationsCollapsed ? 'Expand notifications' : 'Collapse notifications') | translate"
        [matTooltip]="(notificationsCollapsed ? 'Expand notifications' : 'Collapse notifications') | translate"
        matTooltipClass="panel-notifications-tooltip"
        matTooltipPosition="above"
        [matTooltipShowDelay]="250"
        (click)="toggleNotifications($event)">
        <nb-icon [icon]="notificationsCollapsed ? 'arrow-ios-downward-outline' : 'arrow-ios-upward-outline'"></nb-icon>
      </button>
    </div>

    <div *ngIf="notificationsCollapsed" class="panel-notifications-collapsed">
      <ng-container *ngIf="groupedNotifications.length; else collapsedEmptyNotification">
        <span class="panel-collapsed-count">{{ visibleNotificationsCount }}</span>
        <span class="panel-collapsed-summary">
          <span class="panel-collapsed-title">
            {{ visibleNotificationsCount }} {{ 'notifications collapsed' | translate }}
          </span>
          <span class="panel-collapsed-latest">
            {{ 'Latest' | translate }}: {{ groupedNotifications[0].notification.data?.title }}
          </span>
        </span>
      </ng-container>
      <ng-template #collapsedEmptyNotification>
        <span class="panel-collapsed-empty">{{ 'No notifications' | translate }}</span>
      </ng-template>
    </div>

    <ng-container *ngIf="!notificationsCollapsed">
      <div *ngIf="groupedNotifications.length; else emptyNotification" class="panel-notifications-list">
        <div *ngFor="let group of groupedNotifications; let i = index" class="panel-notification">
          <div class="panel-notification-count">{{ group.count }}</div>
          <div class="panel-notification-content">
            <div class="panel-notification-header">
              <span class="panel-notification-title">{{ group.notification.data?.title }}</span>
            </div>
            <p>{{ group.notification.data?.body }}</p>
            <button type="button" class="panel-notification-action" (click)="handleNotificationAction($event, group.notification)">
              {{ getNotificationActionLabel(group.notification) | translate }}
            </button>
          </div>
        </div>
      </div>

      <ng-template #emptyNotification>
        <div class="panel-notifications-list panel-notification-empty">
          <span>{{ 'No notifications' | translate }}</span>
        </div>
      </ng-template>
    </ng-container>
  </div>

  <ng-content></ng-content>
</div>
